import { Configuration, ITEM_NAMES } from "vmd-types";

import { TestAppState } from "../app";

type ItemName = Exclude<Configuration["itemName"], undefined>;

export function getPluralOfItemName(itemName?: ItemName) {
  if (!itemName) {
    return "Tracking Items";
  }

  return (
    ITEM_NAMES.find(({ single }) => single === itemName)?.plural ||
    "Tracking Items"
  );
}

export function getPluralOfItemNameFromState(appState: TestAppState) {
  const itemName = appState.settings?.configuration?.itemName;

  if (!itemName) {
    return "Tracking Items";
  }

  return (
    ITEM_NAMES.find(({ single }) => single === itemName)?.plural ||
    "Tracking Items"
  );
}
